import React, { createContext, useState, useContext } from "react";

const TicketSearchContext = createContext();

export const TicketSearchProvider = ({ children }) => {
  const [globalSearchTerm, setGlobalSearchTerm] = useState("");
  const [searchOnMessages, setSearchOnMessages] = useState(false); // ✅ Desligado por padrão

  return (
    <TicketSearchContext.Provider
      value={{
        globalSearchTerm,
        setGlobalSearchTerm,
        searchOnMessages,
        setSearchOnMessages,
      }}
    >
      {children}
    </TicketSearchContext.Provider>
  );
};

export const useTicketSearch = () => {
  const context = useContext(TicketSearchContext);
  if (!context) {
    throw new Error(
      "useTicketSearch must be used within a TicketSearchProvider"
    );
  }
  return context;
};

